module.exports = __webpack_public_path__ + "img/Screen03.f1a88d58.svg";